//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import { mapState, mapActions } from "vuex";
import AuthService from "@/services/AuthService";
import AppHeader from "./components/header";
import AppMenu from "./components/menu";

export default {
  name: "LayoutDefault",

  computed: {
    ...mapState("main", ["user", "appVersion"]),
  },

  components: { AppMenu: AppMenu, AppHeader: AppHeader },

  watch: {
    $route: {
      immediate: true,
      handler(to) {
        document.title = !to.meta.title
          ? "Abacus Logistics"
          : "Abacus Logistics " + to.meta.title;
      },
    },
  },

  data() {
    return {
      leftDrawerOpen: true,
      title: "Abacus Logistic",
      isLoggedIn: false,
      companyDataLoaded: false,
      auth: null,
    };
  },

  created: function() {
    this.initAuthServiceAndUser();
  },

  methods: {
    ToggleLeftDrawerOpen: function() {
      this.leftDrawerOpen = !this.leftDrawerOpen;
    },

    async initAuthServiceAndUser() {
      this.auth = await AuthService.create();

      this.auth.getUser().then((user) => {
        if (user !== null && !user.expired) {
          this.isLoggedIn = true;
          this.setUser(user.profile);
          this.repeatSilentRenew();
          Promise.allSettled([
            this.getSettings(),
            this.getVatType(),
            this.getAccount(),
            this.getProject(),
            this.getDepartment(),
            this.getLocation(),
            this.getWarehouse(),
            this.getCurrencies(),
            this.getSuppliers(),
            this.getDimensions(),
            this.getDimensionSettings(),
          ]).then((result) => {
            // eslint-disable-next-line no-unused-vars
            const k = result;
            this.companyDataLoaded = true;
          });
        } else {
          console.log("Not logged in");
        }
      });
    },

    login() {
      this.auth.login();
    },

    // check every minute if the token will expire in less than 10 minutes. if true, renew the token.
    async repeatSilentRenew() {
      var user = await this.auth.getUser();
      if (user) {
        var now = Math.floor(Date.now() / 1000);

        console.log(`token expires in ${ user.expires_at - now} seconds`);

        if (user.expires_at - now < 600) {
          console.log("renewing...");
          this.auth.silentRenew();
        }
        setTimeout(this.repeatSilentRenew, 60000);
      }
    },

    ...mapActions("main", [
      "getVatType",
      "getAccount",
      "getProject",
      "getDepartment",
      "getDimensions",
      "getDimensionSettings",
      "getSettings",
      "getLocation",
      "getWarehouse",
      "getCurrencies",
      "getSuppliers",
      "setUser",
    ]),
  },
};
